export const getBaseAsset = (name: string) => {
  switch (name) {
    case "usdt":
      return {
        name: "USDT",
        stable: true,
        executed_amount: 0,
        weight: 0,
        executable: true,
        asset_details: {
          asset_name: "usdt",
          asset_data: {
            id: "tether",
            roi: null,
            name: "Tether",
            image:
              "https://assets.coingecko.com/coins/images/325/large/Tether.png?1668148663",
            symbol: "usdt",
            current_price: 1,
          },
        },
        ask_price: 1,
      };

    case "usdc":
      return {
        name: "USDC",
        stable: true,
        executed_amount: 0,
        weight: 0,
        executable: true,
        asset_details: {
          asset_name: "usdc",
          asset_data: {
            id: "usdc",
            roi: null,
            name: "USDC",
            image:
              "https://assets.coingecko.com/coins/images/6319/standard/usdc.png",
            symbol: "usdc",
            current_price: 1,
          },
        },
        ask_price: 1,
      };

    case "busd":
      return {
        name: "BUSD",
        stable: true,
        executed_amount: 0,
        weight: 0,
        executable: true,
        asset_details: {
          asset_name: "busd",
          asset_data: {
            id: "Binance-Peg BUSD",
            roi: null,
            name: "Binance-Peg BUSD",
            image:
              "https://assets.coingecko.com/coins/images/31273/standard/new_binance-peg-busd.png",
            symbol: "busd",
            current_price: 1,
          },
        },
        ask_price: 1,
      };

    case "usdk":
      return {
        name: "USDK",
        stable: true,
        executed_amount: 0,
        weight: 0,
        executable: true,
        asset_details: {
          asset_name: "usdk",
          asset_data: {
            id: "tether",
            roi: null,
            name: "Tether",
            image:
              "https://assets.coingecko.com/coins/images/8824/large/usdk.png",
            symbol: "usdk",
            current_price: 1,
          },
        },
        ask_price: 1,
      };

    case "usd":
      return {
        name: "USD",
        stable: true,
        executed_amount: 0,
        weight: 0,
        executable: true,
        asset_details: {
          asset_name: "usd",
          asset_data: {
            id: "dollar",
            roi: null,
            name: "Dollar",
            image:
              "https://raw.githubusercontent.com/Lissy93/currency-flags/master/assets/flags_svg/usd.svg",
            symbol: "usd",
            current_price: 1,
          },
        },
        ask_price: 1,
      };

    case "bnb":
      return {
        name: "BNB",
        stable: true,
        executed_amount: 0,
        weight: 0,
        executable: true,
        asset_details: {
          asset_name: "bnb",
          asset_data: {
            id: "bnb",
            roi: null,
            name: "BNB",
            image:
              "https://assets.coingecko.com/coins/images/825/standard/bnb-icon2_2x.png",
            symbol: "bnb",
            current_price: 1,
          },
        },
        ask_price: 1,
      };

    case "eur":
      return {
        name: "EUR",
        stable: true,
        executed_amount: 0,
        weight: 0,
        executable: true,
        asset_details: {
          asset_name: "eur",
          asset_data: {
            id: "eur",
            roi: null,
            name: "Eur",
            image:
              "https://raw.githubusercontent.com/Lissy93/currency-flags/master/assets/flags_svg/eur.svg",
            symbol: "eur",
            current_price: 1,
          },
        },
        ask_price: 1,
      };

    case "btc":
      return {
        name: "BTC",
        stable: true,
        executed_amount: 0,
        weight: 0,
        executable: true,
        asset_details: {
          asset_name: "btc",
          asset_data: {
            id: "btc",
            roi: null,
            name: "Btc",
            image:
              "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png",
            symbol: "btc",
            current_price: 1,
          },
        },
        ask_price: 1,
      };

    default:
      break;
  }
};
